var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v(" "+_vm._s(_vm.item.roleName)+" ")]),(_vm.item.provider)?_c('div',{class:_vm.$style.tooltipContainer},[_c('IconTooltip',[_vm._v(" You don't have permission to edit this administrator. This administrator can only be edited in the Multi-Tenant Portal. ")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }